import { ViewBody } from 'components/Sidebar'
import React from 'react'
import SmartCard from 'components/SmartCard'
import styled from 'styled-components'
import CardBlockerComponent from 'components/CardBlocker'

const UserBlockerCard = styled(ViewBody)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  
  &:not(:last-child) {
    margin-bottom: 10px;
  }

  @media (min-width: 620px) {
    & {
      flex-direction: row;
    }
  }

  & > :first-child {
    flex: 0 0 auto;
    width: 300px;
  }
`

const CardBlockerList: React.FC<{
  cardBlockers: {
    id: number;
    cardId: number;
    name: string;
    description?: any;
    creationDate: number;
    createdBy: string;
    reason?: string;
    userId?: number;
  }[];
}> = ({
  cardBlockers,
}) => {
  return (
    <>
      {cardBlockers.map(cardBlocker => 
        <UserBlockerCard
          key={cardBlocker.id}
        >
          <SmartCard
            hover
            id={cardBlocker.cardId}
          />
          <CardBlockerComponent
            name={cardBlocker.name}
            description={cardBlocker.description}
            creationDate={cardBlocker.creationDate}
            createdBy={cardBlocker.createdBy}
            reason={cardBlocker.reason}
            userId={cardBlocker.userId}
          />
        </UserBlockerCard>
      )}
    </>
  )
}

export default CardBlockerList
